/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha Dhanireddy <snigdha.dhanireddy@mroads.com>, March 2023
 * @flow
 */

import React from 'react';
import PropTypes from 'prop-types';
import classes from './TableActions.module.css';
import Button from '../../../../components/Button';
import { Actions, isActionVisible } from './action-utils';

const TableActions = ({
  selectedItem,
  selectedShape,
  onClosePopup,
  onTableActionClick,
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.closeBtn} onClick={onClosePopup}>X</div>
      <div className={classes.buttonWrapper}>
        {Actions.map(action => {
          const visible = isActionVisible(selectedItem, action.type, selectedShape)
          return (
            <Button
              key={`id-${action.id}-${action.type}`}
              disabled={!visible}
              onClick={() => onTableActionClick(action.type)}
              className={classes.actionBtn}>
              <img src={action.icon} alt={'Img'} className={classes.icon} />
              <div className={classes.actionBtnTxt}>{action.label}</div>
            </Button>
          )
        })}
      </div>
    </div>
  );
};

export default TableActions;

TableActions.propTypes = {
  onClosePopup: PropTypes.func,
  onTableActionClick: PropTypes.func,
  selectedItem: PropTypes.object,
  selectedShape: PropTypes.object,
};

TableActions.defaultProps = {
  onClosePopup: () => { },
  onTableActionClick: () => { },
  selectedItem: {},
  selectedShape: {},
};
